// extracted by mini-css-extract-plugin
export default {"preload":"preload_preload__STynk","spinner":"preload_spinner__SJUBz","spin":"preload_spin__vA1UW"};